import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireAuth } from "../../../lib/auth/route-protection";

/**
 * Product detail is reachable with auth alone so users who lost access (or never
 * had Workspace nav) still see the request-access notice instead of bouncing home.
 * Edit/settings keep module guards on their own routes.
 */
export const Route = createFileRoute("/workspace/products/$productId")({
  beforeLoad: requireAuth(),
  component: () => <Outlet />,
});
